import { render } from "./tasksFilter.vue?vue&type=template&id=446a2c7d"
import script from "./tasksFilter.vue?vue&type=script&lang=js"
export * from "./tasksFilter.vue?vue&type=script&lang=js"

import exportComponent from "/Users/janbergler/NPM/MPM/V3/mpm/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__